import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import FlagStore from '../stores/FlagStore';
import Icon from './Icon/Icon';
import './Checkbox.css';

export default class Checkbox extends Component {
    static propTypes = {
        className: PropTypes.string,

        title: PropTypes.string,
        indeterminate: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        title: '',
        indeterminate: false,
    };

    inputEl = null;

    render() {
        const { className, title, indeterminate, children, ...inputProps } = this.props;

        return <label
            className={cn('Checkbox', className)}
            title={title}
        >
            <input
                className="Checkbox__Input"
                type="checkbox"
                ref={(el) => { this.inputEl = el; }}
                {...inputProps}
            />
            <Icon
                className="Checkbox__IconChecked"
                type={indeterminate ? 'indeterminate_check_box' : 'check_box'}
            />
            <Icon
                className="Checkbox__IconNotChecked"
                type="check_box_outline_blank"
            />
            {children}
        </label>;
    }

    getValue() {
        return this.inputEl && this.inputEl.checked;
    }
}

export const ObservableCheckbox = observer(({ store, ...props }) => <Checkbox
    onChange={store.toggle}
    checked={store.value}
    {...props}
/>);

ObservableCheckbox.propTypes = {
    store: FlagStore.PropType.isRequired,
    ...Checkbox.propTypes,
};
